import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteProductsService = async (productId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/products/${productId}`);
};

export default deleteProductsService;
